import axios from "axios";
import { TokenResponse } from "@/types/auth";
import { buildApiUrl } from "@/utils/api";

export const getToken = async ({ code }: { code: string }) => {
  const { data } = await axios.get<TokenResponse>(buildApiUrl("access/token"), {
    params: {
      code
    }
  });

  return data;
};
